import React, { useEffect, useState } from "react";
import { Camera } from "lucide-react";
// import "./DirectorDashboard.css";
import { getAppliedRoleListForDrCr } from "../../../services/api";
import { Link, useNavigate } from 'react-router-dom';


const DirectorDashboard = () => {
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();

  // 🔥 Dynamic auditions data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAppliedRoleListForDrCr();
        setApplications(res || []);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="dir-dashboard-wrapper">
      <div className="dir-main-section">

        {/* HEADER */}
        <div className="dir-header-row">
            <h1 className="dir-main-title">Director Dashboard</h1>

            <button
                className="dir-post-btn"
                onClick={() => navigate('/dashboard/post-roles')}
            >
                + Post New Role
            </button>
        </div>

        {/* STATS */}
        <div className="dir-stats-row">
          <div className="dir-stat-box">
            <div className="dir-icon red">🎁</div>
            <div>
              <h2>1</h2>
              <p>Active Roles</p>
            </div>
          </div>

          <div className="dir-stat-box">
            <div className="dir-icon red">👥</div>
            <div>
              <h2>0</h2>
              <p>Total Applicants</p>
            </div>
          </div>

          <div className="dir-stat-box">
            <div className="dir-icon red">⭐</div>
            <div>
              <h2>12</h2>
              <p>Shortlisted</p>
            </div>
          </div>
        </div>

       

        <div className="dir-section-header">
            <h2>My Active Roles</h2>

            <Link
                to="/dashboard/roles"
                style={{
                cursor: 'pointer',
                background: 'red',
                padding: '4px 10px',
                borderRadius: '5px',
                color: '#fff',
                textDecoration: 'none'
                }}
            >
                View All
            </Link>
        </div>



<div className="dir-role-box">

  <div className="dir-role-left">
    <div className="dir-role-icon">🎥</div>
    <span className="dir-role-title">Required Male Actor</span>
  </div>

  <div className="dir-role-right">

    <div className="dir-app-count">
      <strong>0</strong>
      <span>Applicants</span>
    </div>

    <span className="dir-open-badge">Open</span>

    <span className="dir-arrow">›</span>

  </div>

</div>



        {/* AUDITIONS */}
        <h2 className="dir-title">Auditions</h2>

{/* <div className="audition-wrapper">
  <div className="table-scroll">
    <table className="audition-table">
      
      <thead>
        <tr>
          <th>TALENT</th>
          <th>ROLE</th>
          <th>PROJECT</th>
          <th>TYPE</th>
          <th>STATUS</th>
        </tr>
      </thead>

      <tbody>
        {applications.length > 0 ? (
          applications.slice(0, 5).map((app, i) => (
            <tr key={i}>
              <td className="bold">{app.talent_name}</td>
              <td>{app.c_role_name}</td>
              <td>{app.c_project_name}</td>
              <td>
                <span className="live">{app.c_audition_type}</span>
              </td>
              <td>{app.c_R_Status}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No applications found</td>
          </tr>
        )}
      </tbody>

    </table>
  </div>
</div> */}

<div className="audition-wrapper">
  <div className="table-scroll">
    <table className="audition-table">
      <thead className="custom-thead">
      
      {/* <thead style={{background:'#1a1a1a !important'}}> */}
        <tr >
          <th>TALENT</th>
          <th>ROLE</th>
          <th>PROJECT</th>
          <th>TYPE</th>
          <th>STATUS</th>
        </tr>
      </thead>

      <tbody>
        {applications.length > 0 ? (
          applications.slice(0, 5).map((app, i) => (
            <tr key={i}>
              <td className="bold">{app.talent_name}</td>
              <td>{app.c_role_name}</td>
              <td>{app.c_project_name}</td>
              <td>
                <span className="live">{app.c_audition_type}</span>
              </td>
              <td>{app.c_R_Status}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5">No applications found</td>
          </tr>
        )}
      </tbody>

    </table>
  </div>
  </div>

      </div>
    </div>
  );
};

export default DirectorDashboard;